import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SevereColdIcon(props: IconProps) {
    return <Icon {...props} iconKey={"severe_cold"}/>
}
